$(function() {
    //ScrollTrigger.normalizeScroll(true);
    // hall change
    $(".bl_hall_ttl:not(.noimage)").on("click mouseenter", function(){
        var id = $(this).attr('id');
        var idnum = $(this).attr('id').replace('js_hall_ttl','');
        var imgid = id.replace('js_hall_ttl','js_hall_img');
        $('.bl_hall_ttl').removeClass('is_current');
        $('.bl_hallBox').removeClass('is_current');
        $('#'+imgid).addClass('is_current');
        $(this).fadeIn(800).addClass('is_current');
        $('.ly_hall').css('background-image','url(https://cdn.shopify.com/s/files/1/0730/2545/4127/files/bg_hall' + idnum + '.webp)');
    });

    // opsodis slider init
    let $slickElement = $('.js_cont_slide_opsodis');
    if (!$slickElement.hasClass('slick-initialized')) {
        $slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            dots: true,
            adaptiveHeight: true,
        });
    }

    // news tab
    var tabs = $(".tab");
    var news = $('.bl_news_line');
    $('.bl_news_line').addClass('is_show');
    $(".bl_news_tab").on("click", function() {
        var cat = $(this).attr('id').replace('tab_','');
        $('.bl_news_line').removeClass('is_show');
        if (cat == 'all'){
            $('.bl_news_line').addClass('is_show');
        } else if(cat == 'news'){
            $('.bl_news_line.cat_news').addClass('is_show');
        } else if(cat == 'tech'){
            $('.bl_news_line.cat_tech').addClass('is_show');
        }
    });

    // product change slide
    if ($('.js_cont_slide_product').length) {
        $('.bl_thumb1, .bl_thumb2').on('click', function() {
        var $parent = $(this).parent();
        if ($(this).is('.bl_thumb1') && $parent.hasClass('thumb_2')) {
            $parent.removeClass('thumb_2').addClass('thumb_1');
        } else if ($(this).is('.bl_thumb2') && $parent.hasClass('thumb_1')) {
            $parent.removeClass('thumb_1').addClass('thumb_2');
        }
        });
    }
    // movie anime
    function createScrollAnimation({ trigger, sequenceId, frameCount, filePrefix, onUpdate, startValue, endValue }) {
        const images = [];
        const imgElement = document.getElementById(sequenceId);
        let loadedFrames = new Set();

        function preloadImage(index) {
            if (loadedFrames.has(index)) return;
            const img = new Image();
            const isSP = window.matchMedia("(max-width: 768px)").matches;
            const filePrefixAdjusted = isSP ? `${filePrefix}_sp` : filePrefix;
            img.src = `https://cdn.shopify.com/s/files/1/0730/2545/4127/files/${filePrefixAdjusted}_${index}.webp`;

            img.onload = () => {
                loadedFrames.add(index);
                if (index === 1) imgElement.src = img.src; // 初期画像セット
            };
            images[index] = img;
        }

        // 最初の画像を読み込み
        preloadImage(1);

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                for (let i = 2; i <= frameCount; i++) {
                    preloadImage(i);
                }
                observer.disconnect();
            }
        }, { threshold: 0.1 });

        observer.observe(document.querySelector(trigger));

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: trigger,
                start: startValue,
                end: endValue,
                scrub: 5,
                pin: trigger,
                fastScrollEnd: true,
                pinSpacing: false,
                anticipatePin: 1,
                fastScrollEnd: false,
                // markers: true,
                onUpdate: (self) => {
                    let rawFrame = self.progress * (frameCount - 1) + 1;
                    let frame = Math.round(gsap.utils.interpolate(1, frameCount, self.progress));  
                    preloadImage(frame);
                    preloadImage(frame + 1);

                    if (images[frame]) {
                        imgElement.src = images[frame].src;
                    }

                    if (onUpdate) onUpdate(frame);
                }
            },
            ease: "power1.out",
            duration: 0.3, // 滑らかに補間
        });
        return tl;
    }

    const isSP = window.matchMedia("(max-width: 768px)").matches;
    const startValue = isSP ? "top 22%" : "top 30%";
    let lastFrame = -1;
    let lastScrollDirection = 0; // 1: 下スクロール, -1: 上スクロール, 0: 初期状態
    const architectureAnimation = createScrollAnimation({
        trigger: ".js_cont_anime_speaker",
        sequenceId: "js_sequence",
        frameCount: 217,
        filePrefix: "mov_architecture",
        startValue: startValue,
        endValue: "+=600%",
        onUpdate: (frame) => {
            if (frame === lastFrame) return; // 同じフレームで処理をしない
            lastFrame = frame;

            requestAnimationFrame(() => {
                const animations = [
                    { selector: ".ly_anime_txtBox.txt_1", start: 49, end: 119 },
                    { selector: ".ly_anime_txtBox.txt_2", start: 142, end: 164 },
                    { selector: ".ly_anime_txtBox.txt_3", start: 180, end: 217 },
                    { selector: ".ly_anime_txtBox.txt_1 .bl_cont_txtArea .p_2", start: 94, end: 119 },
                ];

                animations.forEach(({ selector, start, end }) => {
                    const element = document.querySelector(selector);
                    if (!element) return;

                    const isVisible = frame >= start && frame < end;

                    if (isVisible) {
                        if (!element.classList.contains("is_show")) {
                            element.classList.remove("is_hide");
                            element.classList.add("is_show");
                        }
                    } else {
                        // すでに is_show がついていた要素のみ is_hide にする
                        if (element.classList.contains("is_show")) {
                            element.classList.remove("is_show");
                            element.classList.add("is_hide");
                        }
                    }
                });

                // p_1の処理（p_2が表示されている間はp_1を非表示にする）
                const p1 = document.querySelector(".ly_anime_txtBox.txt_1 .bl_cont_txtArea .p_1");
                const p2 = document.querySelector(".ly_anime_txtBox.txt_1 .bl_cont_txtArea .p_2");

                if (p1 && p2) {
                    if (frame >= 94 && frame < 119) {
                        p1.classList.add("is_hide");
                    } else {
                        p1.classList.remove("is_hide");
                    }
                }
            });
        }
    });
    gsap.to([".ly_mainVisual_txtArea", ".ly_mainVisual_btnArea"], {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".ly_mainVisual",
            start: "top top",
            end: "top+=60px top",
            scrub: true
        }
    });

    const topVisualAnimation = createScrollAnimation({
        trigger: ".ly_mainVisual_imgArea",
        sequenceId: "js_top_sequence",
        frameCount: 315,
        filePrefix: "mov_top",
        startValue: "top top",
        endValue: "+=500%",
        markers: true,
        onUpdate: (frame) => {
            const animations = [
                { selector: ".ly_top_anime_detailBox.detail_1", start: 60, end: 82 },
                { selector: ".ly_top_anime_detailBox.detail_2", start: 99, end: 124 },
                { selector: ".ly_top_anime_txtBox.txt_1", start: 194, end: 219 },
                { selector: ".ly_top_anime_txtBox.txt_2", start: 234, end: 259 },
                { selector: ".ly_top_anime_txtBox.txt_3", start: 305, end: 315 },
            ];

            animations.forEach(({ selector, start, end }) => {
                const element = document.querySelector(selector);
                if (!element) return;

                const isVisible = frame >= start && frame < end;

                if (isVisible && !element.classList.contains("is_show")) {
                    element.classList.remove("is_hide");
                    element.classList.add("is_show");
                } else if (!isVisible && !element.classList.contains("is_hide") && element.classList.contains("is_show")) {
                    // ★ txt_3だけは、フレーム75を超えていたら is_hide を付けない
                    if (selector === ".ly_top_anime_txtBox.txt_3" && frame >= 280) return;

                    element.classList.remove("is_show");
                    element.classList.add("is_hide");
                    setTimeout(function() {
                        element.classList.remove('is_hide');
                    }, 500); // 500ms後に削除 (この時間を変更することで調整)
                }
            });
            const imgArea = document.querySelector("#js_top_sequence");
            if (imgArea) {
                let maxY = window.innerWidth <= 768 ? 80 : 130; // スマホは80、PCは130

                if (frame >= 270 && frame <= 285) {
                    let progress = (frame - 270) / (285 - 270); // 進行度を0〜1で計算
                    let yValue = maxY * progress; // 0〜maxYの範囲で変化
                    gsap.to(imgArea, { y: yValue, duration: 0.2, ease: "power1.out" });
                } else if (frame > 285) {
                    gsap.to(imgArea, { y: maxY, duration: 0.2, ease: "power1.out" });
                } else {
                    gsap.to(imgArea, { y: 0, duration: 0.2, ease: "power1.out" });
                }
            }
        }
    });
    // mainVisualセクションでnormalizeScrollをオン・オフ
    ScrollTrigger.create({
        trigger: "#mainVisual",
        start: "top bottom",
        end: "bottom top",
        onEnter: () => {
            ScrollTrigger.normalizeScroll(true);
            console.log("mainVisual: onEnter → normalizeScroll ON");
        },
        onLeave: () => {
            ScrollTrigger.normalizeScroll(false);
            console.log("mainVisual: onLeave → normalizeScroll OFF");
        },
        onEnterBack: () => {
            ScrollTrigger.normalizeScroll(true);
            console.log("mainVisual: onEnterBack → normalizeScroll ON");
        },
        onLeaveBack: () => {
            ScrollTrigger.normalizeScroll(false);
            console.log("mainVisual: onLeaveBack → normalizeScroll OFF");
        },
    });

    // speakerArchitectureセクションでnormalizeScrollをオン・オフ
    ScrollTrigger.create({
        trigger: "#speakerArchitecture",
        start: "top bottom",
        end: "bottom top",
        onEnter: () => {
            ScrollTrigger.normalizeScroll(true);
            console.log("speakerArchitecture: onEnter → normalizeScroll ON");
        },
        onLeave: () => {
            ScrollTrigger.normalizeScroll(false);
            console.log("speakerArchitecture: onLeave → normalizeScroll OFF");
        },
        onEnterBack: () => {
            ScrollTrigger.normalizeScroll(true);
            console.log("speakerArchitecture: onEnterBack → normalizeScroll ON");
        },
        onLeaveBack: () => {
            ScrollTrigger.normalizeScroll(false);
            console.log("speakerArchitecture: onLeaveBack → normalizeScroll OFF");
        },
    });

    gsap.delayedCall(0.5, function () {
        gsap.to(".ly_mainVisual_txtArea .el_mainVisual_maintxt", {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out"
        });

        gsap.to(".ly_mainVisual_txtArea .el_mainVisual_subtxt", {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
            delay: 0.3
        });

        gsap.to(".ly_mainVisual_btnArea .bl_btn_buy", {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
            delay: 0.6
        });

        gsap.to(".ly_mainVisual_imgArea", {
            opacity: 1,
            filter: "blur(0px)",
            duration: 0.8,
            ease: "power2.out",
            delay: 0.5
        });
    });
});

const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
        ScrollTrigger.refresh();
        observer.disconnect(); // 1回だけ実行
    }
}, { threshold: 0.1 });

observer.observe(document.querySelector(".js_cont_anime_speaker"));

const images = document.querySelectorAll("img");
let loadedImages = 0;
images.forEach(img => {
    if (img.complete) {
        loadedImages++;
    } else {
        img.addEventListener("load", () => {
            loadedImages++;
            if (loadedImages === images.length) {
                ScrollTrigger.refresh();
            }
        });
    }
});
const navArr = [];
function onePageNav(switchName) {
    const navSwitch = $(switchName);
    const deductHeight = 200;
    navArr.length = 0;

    navSwitch.each(function(i) {
        let navSwitchHref = $(this).attr('href');
        let target = $(navSwitchHref);
        if (target.length) {
            let tgtOff = target.offset().top - deductHeight;
            navArr.push({
                switch: $(this),
                tgtOff: tgtOff
            });
        }
    });
    updateNav();
}
function updateNav() {
    let scroll = $(window).scrollTop();
    let currentNav = null;

    for (let i = 0; i < navArr.length; i++) {
        let tgtKey = navArr[i];
        if (scroll > tgtKey.tgtOff) {
            currentNav = tgtKey.switch;
        }
    }
    if (currentNav) {
        $(".js_curnav_switch").removeClass('is_current');
        currentNav.addClass('is_current');
    }
}
onePageNav('.js_curnav_switch');

$(window).on('load resize', function(){
    var width = $(window).width();
    var border = 768;
    if( width >  border){
            // pc slider
            $('.js_cont_slide_product').not('.slick-initialized').slick({
                fade: true,
                dots: true,
                infinite: true,
            });
            $('.js_cont_slide_youtube').not('.slick-initialized').slick({
                infinite: false,
                dots: false,
                variableWidth: true,
                appendArrows: $('.youtube_arrow_box'),
                prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                nextArrow: '<div class="slide-arrow next-arrow"></div>'
            });
            var youtubeslideLength = document.querySelectorAll('.js_cont_slide_youtube .ly_slide_box').length;
            if(youtubeslideLength <= 3){
                $(".js_cont_slide_youtube").addClass("slick_none");
            }
            $(".slick_none.slick-initialized").slick("unslick");

            $('.js_cont_slide_compact').not('.slick-initialized').slick({
                infinite: true,
                dots: true,
                centerMode: true,
                variableWidth: true,
                draggable: true,
            });
            setTimeout(() => {
                $('.js_cont_slide_compact').slick('setPosition');
                $('.js_cont_slide_compact').slick('refresh');
            }, 300);

            $('.js_cont_slide_message').not('.slick-initialized').slick({
                infinite: true,
                dots: true,
                draggable: true,
                fade: true,
                speed: 1000,
                autoplaySpeed: 2000,
                appendArrows: $('.message_arrow_box'),
                prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                nextArrow: '<div class="slide-arrow next-arrow"></div>'
            });
            var $carousel = $('.js_cont_slide_message,.js_cont_slide_compact');
            // slider mouse hover scroll制御
            function disableScroll(e) {
                e.preventDefault();
            }
            $carousel.on('mouseenter', function() {
                window.addEventListener('wheel', disableScroll, { passive: false });
            });
            $carousel.on('mouseleave', function() {
                window.removeEventListener('wheel', disableScroll);
            });
            $carousel.each(function() {
                this.addEventListener("wheel", function(e) {
                    e.preventDefault();

                    var $this = $(this);
                    if (!$this.hasClass('js-slick-moving')) {
                        if (e.deltaY > 0) {
                            $this.slick('slickNext');
                        } else {
                            $this.slick('slickPrev');
                        }
                    }
                }, { passive: false });
            });
            $carousel.on('beforeChange', function(){
                $(this).addClass('js-slick-moving');
            });
            $carousel.on('afterChange', function(){
                $(this).removeClass('js-slick-moving');
            });
    } else {
            // buybtn area
          //  $(window).on("scroll", function() {
          //      var scrollTop = $(this).scrollTop();
          //      var scrollHeight = $(document).height();
          //      var scrollPosition = $(window).height() + scrollTop;
          //      var footHeight = $("footer").innerHeight();
//
          //      if (scrollTop > 200 && (scrollHeight - scrollPosition > footHeight)) {
          //          $(".ly_sp_btnArea").addClass("is_show");
          //      } else {
          //          $(".ly_sp_btnArea").removeClass("is_show");
          //      }
//
          //      if (scrollHeight - scrollPosition <= footHeight) {
          //          $(".ly_sp_btnArea").removeClass("is_show");
          //      }
          //  });

            // sp slider
            $('.js_cont_slide_message').not('.slick-initialized').slick({
                infinite: true,
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '100px',
                slidesToShow: 1,
                variableWidth: true,
                lazyLoad: "progressive",
            });
            $('.js_cont_slide_compact').not('.slick-initialized').slick({
                infinite: true,
                dots: true,
                centerMode: true,
                variableWidth: true,
                draggable: true,
            });
            $('.js_cont_slide_product').not('.slick-initialized').slick({
                fade: true,
                dots: true,
                arrows: false,
                infinite: true,
            });
            $('.js_cont_slide_youtube').not('.slick-initialized').slick({
                infinite: true,
                dots: false,
                arrows: false,
                variableWidth: true,
            });

    }
});
$(window).on('load', function(){
    // menu bg
    const globalMenu = document.querySelector(".ly_global_menu");
    const mainVisual = document.querySelector("#mainVisual");
    function updateBackground() {
        const scrollTop = window.scrollY;
        const mainVisualRect = mainVisual.getBoundingClientRect();
        const mainVisualTop = mainVisualRect.top + scrollTop;
        const mainVisualBottom = mainVisualTop + mainVisualRect.height;

        if (scrollTop <= mainVisualBottom) {
            globalMenu.style.background = "#000";
        } else {
            globalMenu.style.background = "var(--black)";
        }
    }

    // page nav
    let movieOffset = $("#movie").offset().top;
    let footHeight = $("footer").innerHeight();
    
    function updatePagenav() {
        let scrollTop = $(window).scrollTop();
        let scrollHeight = $(document).height();
        let scrollPosition = $(window).height() + scrollTop;

        if (scrollTop >= movieOffset && scrollHeight - scrollPosition > footHeight) {
            $('#js_pagenav').addClass('is_fixed');
        } else {
            $('#js_pagenav').removeClass('is_fixed');
        }
    }
    // 🔹 ページロード時に初回計算
    updatePagenav();
    onePageNav('.js_curnav_switch');
    updateNav();
    updateBackground();

    // 🔹 スクロール時にもupdatePagenavを実行
    $(window).on('scroll', function() {
        updatePagenav();
        onePageNav('.js_curnav_switch');
        updateNav();
        updateBackground();
    });

    $(window).on('resize', function() {
        ScrollTrigger.refresh();
        onePageNav('.js_curnav_switch');
        updatePagenav();
        updateNav();
    });


    // opsodis more cont btn
    $('#js_opsodis_moreBtn').click(function() {
        let $this = $(this);
        let $content = $this.next();
        let $slickElement = $('.js_cont_slide_opsodis');

        if (!$this.hasClass('is_open')) {
            $slickElement.slick('setPosition');
            $content.fadeIn(500, function() {
                $slickElement.slick('setPosition');

                setTimeout(() => {
                    ScrollTrigger.refresh();
                    onePageNav('.js_curnav_switch'); // 高さを再計算
                    updateNav(); // ナビの表示を更新
                }, 1000);
            });

            let scroll = $('#js_opsodis_moreCont').offset().top - 200;
            $('html, body').animate({scrollTop: scroll});
        } else {
            $content.fadeOut(500, function() {
                setTimeout(() => {
                    ScrollTrigger.refresh();
                    onePageNav('.js_curnav_switch');
                    updateNav();
                }, 1000);
            });
        }
        $this.toggleClass('is_open');
    });

    // slider
    $('.js_cont_slide_soundmode').slick({
        infinite: true,
        dots: true,
        appendArrows: $('.soundmode_arrow_box'),
        prevArrow: '<div class="slide-arrow prev-arrow"></div>',
        nextArrow: '<div class="slide-arrow next-arrow"></div>'
    });

    var $carousel = $('.js_cont_slide_soundmode');
    // slider mouse hover scroll制御
    function disableScroll(e) {
        e.preventDefault();
    }
    $carousel.on('mouseenter', function() {
        window.addEventListener('wheel', disableScroll, { passive: false });
    });
    $carousel.on('mouseleave', function() {
        window.removeEventListener('wheel', disableScroll);
    });
    $carousel.each(function() {
        this.addEventListener("wheel", function(e) {
            e.preventDefault();

            var $this = $(this);
            if (!$this.hasClass('js-slick-moving')) {
                if (e.deltaY > 0) {
                    $this.slick('slickNext');
                } else {
                    $this.slick('slickPrev');
                }
            }
        }, { passive: false });
    });
    $carousel.on('beforeChange', function(){
        $(this).addClass('js-slick-moving');
    });
    $carousel.on('afterChange', function(){
        $(this).removeClass('js-slick-moving');
    });

});